// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.is-invalid {
  border-right-width: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/input-number/input-number.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF","sourcesContent":["input.is-invalid {\n  border-right-width: 5px;\n  //background-color: $danger;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
